import component from './PhChatCenteredText.vue_vue_type_script_lang.vue.js';
export { default } from './PhChatCenteredText.vue_vue_type_script_lang.vue.js';
import { render } from './PhChatCenteredText.vue_vue_type_template_id_575fce9c_lang.vue.js';

component.render = render;
